export class StandardResponseModel {
    count: number
    next: string
    previous: string
    results: [StandardItemModel]
}

export class StandardItemModel {
    id: number
    name: string
}

export class StatusReputation{
    status:[StandardItemModel]
    reputation:[StandardItemModel]
}

export class StatusResponseModel {
    count: number
    next: string
    previous: string
    results: [StatusItemModel]
}

export class StatusItemModel {
    id: number
    name: string
    hexcolor: string

}